export module omsenum {
    export enum ErrorCode {
        Unauthorized = 401,
        NotFound = 404,
        ValidationError = 400,
        InternalServerError = 500,
        EntityIsInInvalidState = 601
    }
}
export module omsenum {
    export enum SortOrder {
        None = 0,
        Asc = 1,
        Desc = 2
    }
}
